import { render, staticRenderFns } from "./SearchRecentlyConsulted.vue?vue&type=template&id=ccd94070&scoped=true&"
import script from "./SearchRecentlyConsulted.vue?vue&type=script&lang=js&"
export * from "./SearchRecentlyConsulted.vue?vue&type=script&lang=js&"
import style0 from "./SearchRecentlyConsulted.vue?vue&type=style&index=0&id=ccd94070&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd94070",
  null
  
)

export default component.exports